import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';
import { DashboardLayout, normalizeDashboardLayout } from '../pages/ProjectDashboardPage/dashboardLayout';

/**
 * 개요 위젯 배치 API 클라이언트.
 *
 * 백엔드는 projects.dashboard_layout JSON 컬럼에 통째로 저장(opaque blob).
 * 미저장 프로젝트는 null 을 반환하므로 normalizeDashboardLayout 이 기본 배치로 채운다.
 */

interface DashboardLayoutApiResponse {
  success: boolean;
  message: string;
  data?: unknown;
}

export class DashboardLayoutService {
  static async get(projectId: number): Promise<DashboardLayout> {
    const response = await apiClient.get<DashboardLayoutApiResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.DASHBOARD_LAYOUT.GET(projectId),
    );
    if (!response.data.success) {
      throw new Error(response.data.message || '위젯 배치 조회 실패');
    }
    return normalizeDashboardLayout(response.data.data as DashboardLayout | null | undefined);
  }

  static async update(projectId: number, layout: DashboardLayout): Promise<void> {
    const response = await apiClient.put<DashboardLayoutApiResponse>(
      API_ENDPOINTS.SITE_MANAGEMENT.DASHBOARD_LAYOUT.UPDATE(projectId),
      layout,
    );
    if (!response.data.success) {
      throw new Error(response.data.message || '위젯 배치 저장 실패');
    }
  }
}
